import * as connActions from "../actions/ConnectionActions";
import { ConnectionState, initialState } from "../store/ConnectionState";
import buildReducer from "../utils/ReducerBuilder";

export const ConnectionReducer = buildReducer<ConnectionState>(initialState)
    .handle(connActions.onStatusUpdate, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            connected: action.payload.all,
            apiConnected: action.payload.api,
            servicesConnected: action.payload.services,
            displayConnectedWarning: action.payload.displayConnectedWarning,
            initialized: action.payload.initialized !== undefined
                ? action.payload.initialized
                : state.initialized,
        };
    })
    .handle(connActions.onIsReconnected, (state, action) => ({
        ...state,
        isReconnected: action.payload || false,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/reducers/ConnectionReducer.ts